import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Skeleton } from '@mui/material';

const ComparisonTableSkeleton: React.FC = () => {
  const headerCols = 4; 
  const rowCount = 12;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
            <TableCell sx={{ fontWeight: 600, minWidth: 150 }}>
              <Skeleton width={120} height={28} />
            </TableCell>
            {Array.from({ length: headerCols }).map((_, i) => (
              <TableCell key={i} align="center" sx={{ fontWeight: 600, minWidth: 120 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 0.5 }}>
                  <Skeleton width={140} height={18} />
                  <Skeleton width={100} height={14} />
                </Box>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rowCount }).map((_, r) => (
            <TableRow key={r} hover>
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Skeleton variant="rectangular" width={28} height={28} sx={{ borderRadius: 1 }} />
                  <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
                    <Skeleton width={100} height={20} />
                    <Skeleton width={60} height={14} />
                  </Box>
                </Box>
              </TableCell>
              {Array.from({ length: headerCols }).map((_, c) => (
                <TableCell key={c} align="center">
                  <Skeleton width={80} height={20} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ComparisonTableSkeleton;